import React from "react";

const Uk = () => {
  return (
    <svg
      width="38"
      height="28"
      style={{ transform: "scale(0.8)" }}
      viewBox="0 0 38 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_5839_108265" maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="28">
        <path
          d="M0 2.42871C0 1.32414 0.89543 0.428711 2 0.428711H36C37.1046 0.428711 38 1.32414 38 2.42871V25.5716C38 26.6761 37.1046 27.5716 36 27.5716H2C0.89543 27.5716 0 26.6761 0 25.5716V2.42871Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5839_108265)">
        <path d="M0 0.428711H38V27.5716H0V0.428711Z" fill="white" />
        <path d="M0 0.428711H38V27.5716H0V0.428711Z" fill="#0A17A7" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M-1.74272 -2.17149L14.4738 8.76708V-1.38028H23.5205V8.76572L39.7383 -2.17285L41.7605 0.827791L28.9396 9.47686H37.9971V18.5236H28.9396L41.7619 27.1726L39.737 30.1719L23.5205 19.2334V29.3807H14.4738V19.2347L-1.74408 30.1733L-3.76622 27.1726L9.05471 18.5236H-0.00286365V9.47686H9.05471L-3.76758 0.827791L-1.74272 -2.17149Z"
          fill="white"
        />
        <path
          d="M12.6062 18.8926L-5.20898 30.7065M25.3335 9.02207L42.5217 -2.28564L25.3335 9.02207ZM27.1589 19.0174L42.5679 29.4036L27.1589 19.0174ZM10.8637 8.99221L-5.20898 -1.83779L10.8637 8.99221Z"
          stroke="#DB1F35"
          strokeWidth="0.667"
          stroke-linecap="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 16.7144H16.2857V27.5716H21.7143V16.7144H38V11.2859H21.7143V0.428711H16.2857V11.2859H0V16.7144Z"
          fill="#E6273E"
        />
      </g>
    </svg>
  );
};

export default Uk;
